<template>
  <div
    class="
      container-fluid
      blog-container
      masthead
      d-flex
      align-items-center
      justify-content-center
      ptb-2
    "
  >
    <div class="col-xl-11">
      <div class="row blog-row p-4 blog-box-shadow">
        <div class="col-md-8 px-5">
          <div class="blog-img">
            <!-- <img src="@/assets/imgs/blog-9.jpg" class="img-fluid blog-img" /> -->
            <!-- Heading -->
            <h1
              class="blog-title blog-heading text-start mb-4"
              v-html="heading"
            ></h1>
            <img
              :src="`https://cms.aliff.in${image}`"
              class="img-fluid mb-4 blog-img blog-image"
            />
            <!-- Image -->
          </div>
          <div class="blog-content">
            <div>
              <h3 v-if="isLoading">Loading...</h3>
              <vue-markdown v-else :source="markdownContent"></vue-markdown>
            </div>
          </div>
        </div>

        <RecentBlogs class="recent-overflow" />

        <div class="container mx-auto">
          <ContactusSection class="contact-blog-1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactusSection from "@/components/partials/ContactusSection.vue";
import RecentBlogs from "@/components/partials/RecentBlogs.vue";
import { mapGetters } from "vuex";
import StrapiServices from "@/apiServices/StrapiServices";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    ContactusSection,
    RecentBlogs,
    VueMarkdown
  },
  watch: {
    "$route.params.id"() {
      this.loadBlog();
    }
  },
  computed: {
    ...mapGetters(["getBlogs"])
  },
  data() {
    return {
      id: null,
      heading: null,
      paragraph: null,
      seo_url: null,
      image: null,
      isLoading: true,
      markdownContent: ""
    };
  },
  async mounted() {
    await this.getBlogContent();
    this.isLoading = false;
  },
  methods: {
    async getBlogContent() {
      try {
        const response = await StrapiServices.getBlog({ id: this.id });
        this.heading = response.data.data.attributes.heading;
        this.paragraph = response.data.data.attributes.paragraph;
        this.seo_url = response.data.data.attributes.seo_url;
        this.image = response.data.data.attributes.image.data.attributes.url;

        this.markdownContent = this.paragraph;

        this.isLoading = false;
      } catch (err) {
        console.log("Error in getting  ", err);
        this.isLoading = false;
      }
    },
    loadBlog() {
      console.log({ bolgs: this.getBlogs });
      const { id } = this.$route.params;
      if (isNaN(id)) {
        this.id = this.getBlogs[0].id;
      } else {
        this.id = id;
      }
      this.getBlogContent();
    }
  },
  beforeMount() {
    this.loadBlog();
  }
};
</script>
<style>
.blog-img {
  border-radius: 0.75rem;
}

.blog-img-1 {
  border-radius: 0.3125rem;
  object-fit: cover;
  height: 100%;
  aspect-ratio: 4/3;
}
.recent-overflow {
  height: 180vh;
  overflow-y: scroll;
  padding: 1.25rem;
  /* border-radius: .625rem; */
  /* box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.2); */
}
.blog-image {
  width: 100%;
}
.blog-heading {
  font-family: "Fira Sans", sans-serif;
  transition: all 0.5s ease-in;
  background: rgb(83, 103, 255);
  background: -o-linear-gradient(
    308deg,
    rgba(83, 103, 255, 1) 0%,
    rgba(0, 208, 156, 1) 53%
  );
  background: linear-gradient(
    142deg,
    rgba(83, 103, 255, 1) 0%,
    rgba(0, 208, 156, 1) 53%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.mt-5 {
  text-align: center; /* Align the button to the center */
}

.btn-secondary-red-2 {
  width: 100%; /* Make the button occupy the full width of its container */
  max-width: 18.75rem; /* Set a maximum width for the button */
  padding: 0.5625rem;
  font-size: 0.9375rem;
  background: linear-gradient(90deg, #ff7a00 0%, #ff3d00 100%);
  border-radius: 0.25rem;
  /* padding: 8px 48px; */
  color: #fff;
  text-transform: capitalize;
  text-decoration: none;
  border: none;
  box-shadow: 0 0.625rem 1.25rem #286fdb4d;
  max-width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Blogs/Blog.vue